var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExtraMenuBalance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.2002 13.2H2.0002H8.0002H8.18905L8.35797 13.2845L14.1125 16.1617L21.0128 14.7817C22.4433 14.4955 23.1875 16.4206 21.9365 17.1712L14.4118 21.686L14.1276 21.8565L13.8062 21.7761L5.90171 19.8H2.0002H1.2002V19V14V13.2ZM2.8002 14.8V18.2H6.0002H6.09868L6.19422 18.2239L13.8727 20.1435L19.6282 16.6903L14.1571 17.7845L13.8879 17.8383L13.6424 17.7156L7.81134 14.8H2.8002Z",
    fill: "#111114"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8334 10.8818C14.2864 10.3859 16.1211 8.38853 16.1211 6C16.1211 3.61147 14.2864 1.61412 11.8334 1.11824C12.2163 1.04082 12.6144 1 13.0229 1C16.0478 1 18.5 3.23858 18.5 6C18.5 8.76142 16.0478 11 13.0229 11C12.6144 11 12.2163 10.9592 11.8334 10.8818Z",
    fill: "#111114",
    fillOpacity: 0.24
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 11C13.7614 11 16 8.76142 16 6C16 3.23858 13.7614 1 11 1C8.23858 1 6 3.23858 6 6C6 8.76142 8.23858 11 11 11ZM8.94872 4.46154V3.69231H13.0513V4.46154H8.94872ZM8.94872 6V5.23077H13.0513V6H11.5128V8.5641H10.4872V6H8.94872Z",
    fill: "#111114"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtraMenuBalance);
export default __webpack_public_path__ + "static/media/extra_menu_balance.ca22ee4dc7c58d43a95b7df4a6dc2be7.svg";
export { ForwardRef as ReactComponent };